import { cn } from "@/shared/lib/css";

interface ServiceIconProps {
  serviceId: string;
  className?: string;
}

export function ServiceIcon({ serviceId, className }: ServiceIconProps) {
  serviceId = serviceId.toLowerCase().replace(".", "_");

  return (
    <svg className={cn(className)}>
      <use href={`/images/services-sprite.svg#${serviceId}`} />
    </svg>
  );
}
